/* eslint-disable max-statements-per-line */
import type {
    Column,
    Hooks,
    TableToggleAllRowsSelectedProps,
} from 'react-table';

import { Checkbox } from '@catalyze/ui';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const prepareCheckboxes = (): Column<any> => ({
    id: 'selection',
    maxWidth: 24,
    disableSortBy: true,
    Header: ({
        isAllRowsSelected,
        toggleAllRowsSelected,
        getToggleAllRowsSelectedProps,
    }: Hooks) => {
        const props: TableToggleAllRowsSelectedProps =
            // Needed because of invalid typings in react-table library
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (getToggleAllRowsSelectedProps as any)?.();
        return (
            <Checkbox
                uniqueKey="Header-0"
                checked={isAllRowsSelected}
                handleOnChange={toggleAllRowsSelected}
                indetermined={props?.indeterminate}
            />
        );
    },
    Cell: ({ row: { isSelected, toggleRowSelected, id } }: Hooks) => (
        <Checkbox
            uniqueKey={`Cell-${id}`}
            checked={isSelected}
            handleOnChange={() => {
                toggleRowSelected();
                window.scrollTo(0, 0);
            }}
        />
    ),
});
